import { useState, useCallback } from 'react';
import { DeploymentConfig } from '../Model/Deployment';
import { DeploymentService } from '../Service/DeploymentService';

export const useDeploymentViewModel = () => {
  const [step, setStep] = useState(1);
  const [deploymentId, setDeploymentId] = useState("");
  const [config, setConfig] = useState<DeploymentConfig>({
    app_name: '',
    repo_name: '',
    env_vars: {},
    resources: {
      cpu: 2,
      memory: 2,
      minInstances: 1,
      maxInstances: 5,
    },
    monitoring: false,
    cloud_ref_id: '',
    ci_cd: false,
    selected_cloud:'AWS',
    service_selected:'',
    branch:'',
    status:'Active',
    deployment_env:'development',
    deployment_result:'',
    is_cicd_trigger_on:false
  });
  

  const updateConfig = useCallback((updates: Partial<DeploymentConfig>) => {
    setConfig(prev => ({ ...prev, ...updates }));
  }, []);

  const deploy = useCallback(async (deployment:DeploymentConfig) => {
     try {
          const res = await DeploymentService.CreateDeployment(deployment);
          return res;
        } catch (error) {
          console.error("Failed to create deployment:", error);
        }
  }, []);

  const getDeploymentDetails = useCallback(async (id:string) => {
    try {
         const deployment = await DeploymentService.GetDeployment(id);
         return deployment;
       } catch (error) {
         console.error("Failed to create deployment:", error);
         return null;
       }
 }, []);

  const triggerDeployment = useCallback(async (id:string) => {
    try {
         const res = await DeploymentService.TriggerDeployment(id);
         return res;
       } catch (error) {
         console.error("Failed to trigger deployment:", error);
         return null;
       }
 }, []);

 const getDeploymentLogs = useCallback(async (id:string) => {
  try {
       const deployment = await DeploymentService.GetDeploymentLogs(id);
       return deployment;
     } catch (error) {
       console.error("Failed to get deployment logs:", error);
       return null;
     }

  
}, []);

const getHostedLink = useCallback(async (id:string)=>{
    try{
      const hosted_data = await DeploymentService.GetHostedLink(id);
      return hosted_data
    }catch (error) {
       console.error("Failed to get deployment logs:", error);
       return null;
     }
  },[])



  return { step, setStep, config, updateConfig, deploy, triggerDeployment, getDeploymentDetails, getDeploymentLogs, getHostedLink };
};